import React, { memo } from 'react';
import BtnSong from './BtnSong';
import { songYannGorrig } from './songs';

const BtnSongYannGorrig = () => {
  return (
    <BtnSong title={songYannGorrig.getTitle()}>
      {songYannGorrig.getLyrics()}
    </BtnSong>
  );
};

export default memo(BtnSongYannGorrig);
